import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";

export const useUnsavedChangesGuard = (isDirty) => {
    const [isConfirmOpen, setIsConfirmOpen] = useState(false);
    const pendingActionRef = useRef(null);

    const requestChange = useCallback((action) => {
        if (isDirty) {
            pendingActionRef.current = action;
            setIsConfirmOpen(true);
        } else {
            action();
        }
    }, [isDirty]);

    const confirmChange = useCallback(() => {
        setIsConfirmOpen(false);
        if (pendingActionRef.current) {
            pendingActionRef.current();
            pendingActionRef.current = null;
        }
    }, []);

    const cancelChange = useCallback(() => {
        setIsConfirmOpen(false);
        pendingActionRef.current = null;
    }, []);

    return { requestChange, isConfirmOpen, confirmChange, cancelChange };
};

export const useGuardedActiveKeyChange = (sectionRef, activeKey, setActiveKey) => (
    useCallback((nextKey) => {
        if (nextKey === activeKey) return;
        if (sectionRef.current) {
            sectionRef.current.requestChange(() => setActiveKey(nextKey));
        } else {
            setActiveKey(nextKey);
        }
    }, [sectionRef, activeKey, setActiveKey])
);

export const useUnsavedChangesReporter = (isDirty) => {
    const setIsDirty = useContext(UnsavedChangesContext);
    useEffect(() => {
        if (setIsDirty) {
            setIsDirty(isDirty);
        }
    }, [isDirty, setIsDirty]);
};

export const UnsavedChangesContext = createContext(null);


